<div class="skeleton-container" [class]="animationClass">
  <!-- Skeleton para texto -->
  <div *ngIf="type === 'text'" class="skeleton-text">
    <div 
      *ngFor="let line of skeletonLines; let i = index" 
      class="skeleton-line"
      [style.width]="i === skeletonLines.length - 1 ? '60%' : '100%'"
      [style.height]="skeletonHeight">
    </div>
  </div>

  <!-- Skeleton para card -->
  <div *ngIf="type === 'card'" class="skeleton-card">
    <div class="skeleton-card-header">
      <div class="skeleton-circle"></div>
      <div class="skeleton-text-content">
        <div class="skeleton-line" [style.width]="'80%'"></div>
        <div class="skeleton-line" [style.width]="'60%'"></div>
      </div>
    </div>
    <div class="skeleton-card-body">
      <div class="skeleton-line" [style.width]="'100%'"></div>
      <div class="skeleton-line" [style.width]="'90%'"></div>
      <div class="skeleton-line" [style.width]="'70%'"></div>
    </div>
  </div>

  <!-- Skeleton para lista -->
  <div *ngIf="type === 'list'" class="skeleton-list">
    <div *ngFor="let line of skeletonLines" class="skeleton-list-item">
      <div class="skeleton-circle"></div>
      <div class="skeleton-text-content">
        <div class="skeleton-line" [style.width]="'80%'"></div>
        <div class="skeleton-line" [style.width]="'60%'"></div>
      </div>
    </div>
  </div>

  <!-- Skeleton para calendário -->
  <div *ngIf="type === 'calendar'" class="skeleton-calendar">
    <div class="skeleton-calendar-header">
      <div class="skeleton-line" [style.width]="'40%'"></div>
    </div>
    <div class="skeleton-calendar-grid">
      <div *ngFor="let day of Array(35).fill(0)" class="skeleton-calendar-day">
        <div class="skeleton-circle"></div>
      </div>
    </div>
  </div>

  <!-- Skeleton para tabela -->
  <div *ngIf="type === 'table'" class="skeleton-table">
    <div class="skeleton-table-header">
      <div *ngFor="let col of Array(4).fill(0)" class="skeleton-line" [style.width]="'100%'"></div>
    </div>
    <div *ngFor="let row of Array(5).fill(0)" class="skeleton-table-row">
      <div *ngFor="let col of Array(4).fill(0)" class="skeleton-line" [style.width]="'90%'"></div>
    </div>
  </div>
</div>
